import PatternBuilder from "./patternBuilder"
import PatternBuilderConfig from "./patternBuilderConfig"
import PatternBuilderCart from "./PatternBuilderCart"
import AppInstance from "./AppInstance"
import View from "./View"
import Pattern from "./pattern"
import Favorites from "./favorites"
import GeneralHelper from "./generalHelper"
import MetaFiles from "./metafiles"

//import "../css/loader.css"
import "../css/rangeslider.css"

import "../css/style.css"
import "../css/plugins.css"
import "../css/wizardcore.css"
import "../css/mobile.css"
import "../css/colorbox.css"
import "../css/patternbuilder.css"
import "../css/loader.css"
import { General } from "./metafiles"

const conf = new PatternBuilderConfig();
//set any needed conf changes

//Dev

conf.SERVICE_BASE       =  GeneralHelper.get_query_string("SERVICE_BASE")      || "cxcore-cadcut-patterns-staging.azurewebsites.net";
conf.USE_CDN            =  true ;
conf.SESSIONID          =  GeneralHelper.get_query_string("SESSIONID")         || "c291d8c8-e050-4872-91d0-57b4f55d65ce";
conf.CONFIG             =  GeneralHelper.get_query_string("CONFIG")            || "SidPatterns";
conf.SUPERUSER          =  GeneralHelper.get_query_string("SUPERUSER")         || false;
conf.CDN                =  GeneralHelper.get_query_string("CDN")               || conf.SERVICE_BASE + "/cdn/";
conf.SETNAME            =  GeneralHelper.get_query_string("SETNAME") ? decodeURIComponent(GeneralHelper.get_query_string("SETNAME")) : "/PUBLIC/DESIGNER" ;
conf.SETNAMEPRODUCTION  =  GeneralHelper.get_query_string("SETNAMEPRODUCTION") || "/PRIVATE/PRODUCTION/" ;
conf.SSL                =  GeneralHelper.get_query_string("SSL")               || true ;
conf.LOCALE             =  GeneralHelper.get_query_string("LOCAL")            || "en-US" ;
conf.STAHLS_API_BASE    =  GeneralHelper.get_query_string("STAHLS_API_BASE") ? decodeURIComponent(GeneralHelper.get_query_string("STAHLS_API_BASE")) : "https://api.stahls.com/" ;
conf.MODALERROR         =  GeneralHelper.get_query_string("MODALERROR")        || false ;
conf.SHOPPER_COUNTRY   =  parseLocalParm(conf.SHOPPER_COUNTRY, GeneralHelper.get_query_string("LOCAL"));

const ai = new AppInstance(conf);

ai.instance().SHOW_DOWNLOAD   =  GeneralHelper.get_query_string("SHOW_DOWNLOAD") || false ;
ai.instance().FIELDNAME       =  GeneralHelper.get_query_string("FIELDNAME");
ai.instance().STEPINDEX       =  GeneralHelper.get_query_string("STEPINDEX");
ai.instance().EDITPATTERNID   =  GeneralHelper.get_query_string("EDITPATTERNID");
ai.instance().ARTWORKUPLOADER =  ai.is_art_uploader();

ai.instance().DEFAULTPATTERNID   =  GeneralHelper.get_query_string("DEFAULTPATTERNID")        || false ;
ai.instance().DEFAULTCATEGORY    =  GeneralHelper.get_query_string("DEFAULTCATEGORY") ? conf.SETNAME + "/" + decodeURIComponent(GeneralHelper.get_query_string("DEFAULTCATEGORY")) : null ;

ai.instance().GROUPID         =  GeneralHelper.get_query_string("GROUPID");
ai.instance().SHOPPERID       =  GeneralHelper.get_query_string("SHOPPERID");
ai.instance().CUSTOMER_HASH   =  GeneralHelper.get_query_string("customerHash");


function parseLocalParm(def, local)
{
  if (!local)
    return def;
  else if (local == 'en-CA')
    return 'CAN';
  else 
    return def;
}
//Object.freeze(ai);

const instance = new PatternBuilder(conf);
//Object.freeze(instance);

//const cart = new PatternBuilderCart(); this is now static

//test singleton
// const instance2 = new PatternBuilder(conf);
// Object.freeze(instance2);
//works!

//PatternBuilder.renderTo("PatternBuilderContainer");

window.AppInstance = ai ;
window.PatternBuilder = instance ;
window.PatternBuilderCart = PatternBuilderCart ;
window.load_content$ = View.load_content$ ;
window.load_pattern_and_metafiles = Pattern.load_pattern_and_metafiles ;
window.open_digital_palette = View.open_digital_palette ;
window.palette_select_color = View.palette_select_color ;
window.update_vector_swatches = Pattern.update_vector_swatches ;
window.update_pickers = Pattern.update_pickers ;
window.collection_home = View.collection_home ;
window.Favorites = Favorites ;
window.get_production_document_link = Pattern.get_production_document_link$ ;
window.resetPatternBuilder = View.resetPatternBuilder ;
window.viewResetPatternBuilder = View.checkResetPatternBuilder ;
window.reset_browser_piece = MetaFiles.reset_browser_piece ;

Cx.Config.set({
  server: window.PatternBuilder.config().SERVICE_BASE
  , sid:window.PatternBuilder.config().SESSIONID
  , su: window.PatternBuilder.config().SUPERUSER
  , ssl: window.PatternBuilder.config().SSL
  , config: window.PatternBuilder.config().CONFIG
  , cdn: window.PatternBuilder.config().CDN
  , jquery: true
  , localization: {
    implementation: 'googlev2',
    gKey: 'AIzaSyDEJhJMzS2O7ZAeBf2_ttZbCg8IKEiOpcY'
  }
  , logger: {
      clientToken: window.PatternBuilder.config().CLIENTTOKEN
  ,   serverToken: window.PatternBuilder.config().SERVERTOKEN
}
, keepLowerLeftCornerAsOrigin : true
});

Cx.js(
  Cx.CoreJS({ base: 'https://cadxcdn.blob.core.windows.net/core-6-2-8/' }) // Include core (REQUIRED)
  , Cx.Grafika({ base: 'https://cadxcdn.blob.core.windows.net/grafika-6-1-30/', modules: ['2D','Tools'] }) // Include Grafika
  , window.PatternBuilder.config().RULERBAR_PATH
);

Cx.ready(function () {
  // if ( ai.instance().SHOPPERID && ai.instance().SHOPPERID.length > 0 && ai.instance().CUSTOMER_HASH && ai.instance().CUSTOMER_HASH.length > 0 )
  // {
  //   //GeneralHelper.do_external_login$(ai.instance().CUSTOMER_HASH, ai.instance().SHOPPERID).then(function(f){
  //     window.PatternBuilder.render("PatternBuilderContainer");
  //   //});
  // }
  // else {
    window.PatternBuilder.render("PatternBuilderContainer");
  //}
  //GeneralHelper.do_external_login$('R9PJGLE2XRL79JCTCXTJNCQEJD500439', 'C3A71AE787EAA4E56573D7413DC73190254EE8C3');
  //EventSubscriber.Subscribe();
  //setTimeout(BackgroundLoader.recursive_load(window.AppInstance.instance().pattern_set_name), 0); //new thread
  //BackgroundLoader.recursive_load(window.AppInstance.instance().pattern_set_name);
});

